interface WizardInfo {
  currentStep: number
  totalSteps: number
  hasAgendaStep: boolean
}

interface Props {
  wizard: WizardInfo
  labels: {
    stepLanding: string
    stepForm: string
    stepAgenda: string
    stepConfirmation: string
  }
  primaryColor?: string
  textColor?: string
  className?: string
}

export default function RegistrationStepIndicator({ wizard, labels, className = '' }: Props) {
  const steps = [
    { num: 1, label: labels.stepLanding },
    { num: 2, label: labels.stepForm },
    ...(wizard.hasAgendaStep ? [{ num: 3, label: labels.stepAgenda }] : []),
    { num: wizard.totalSteps, label: labels.stepConfirmation },
  ]

  return (
    <ol className={`ev-reg-steps ev-reg-steps-connected mb-6 flex flex-wrap items-center justify-center gap-2 sm:gap-4 ${className}`.trim()}>
      {steps.map((step) => {
        const active = step.num === wizard.currentStep
        const done = step.num < wizard.currentStep
        const stateClass = active ? 'ev-reg-step-active' : done ? 'ev-reg-step-done' : 'ev-reg-step-pending'
        return (
          <li key={step.num} className={`ev-reg-step ev-reg-step-${step.num} ${stateClass} flex items-center gap-2`}>
            <span className="ev-reg-step-num flex h-7 w-7 items-center justify-center rounded-full border text-xs font-semibold">
              {step.num}
            </span>
            <span className="ev-reg-step-label hidden text-xs font-medium sm:inline">
              {step.label}
            </span>
          </li>
        )
      })}
    </ol>
  )
}
